// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "components-MainPage" + "." + "f177f47f01a33b49a49b" + ".css";
};